const {generateServiceLangsOptions} = require("./helpers");
const {setDefaultSubproduct} = require('./../subproducts-list/subproducts-selection');

$(document).ready(function () {
    if($('.single-service-page').length === 0) {
        return;
    }
    generateServiceLangsOptions($('#tour_lang'), $('#private_or_group').val());

    $('.servicePrivacySwitcher__button').on('click', function () {
        $('#private_or_group').val($(this).data('privacy-type')).change();
    });

    $('#private_or_group').on('change', function () {
        setPrivacyType($(this).val());
    });

    function setPrivacyType(privacyType) {
        $('.subproductsListComponent .preloadMask').show();
        $('.servicePrivacySwitcher__button').removeClass('active');
        $(`.servicePrivacySwitcher__button[data-privacy-type="${privacyType}"]`).addClass('active');
        let privateSection = $('#servicePrivateSection');
        let sharedSection = $('#serviceSharedSection');
        let privateDescription = $('.service_private_description');
        let groupDescription = $('.service_group_description');
        let tourLangInput = $('#tour_lang');
        if (privacyType === 'Private') {
            privateSection.removeClass('d-none');
            sharedSection.addClass('d-none');
            privateDescription.show();
            groupDescription.hide();

        } else {
            privateSection.addClass('d-none');
            sharedSection.removeClass('d-none');
            privateDescription.hide();
            groupDescription.show();
        }

        generateServiceLangsOptions(tourLangInput, privacyType);
        setDefaultSubproduct(privacyType);
    }
});
